import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { toast } from "react-toastify";

class SectionForm extends Component {
    state = { id: "", entitled_section: "", short_entitled_section: "", yearId: "", years: [], errors: {}, loading: false, saving: false, loadError: "" };

    loadForm = async () => {
        const item = this.props.formData;
        this.setState({
            id: item?.id || "", entitled_section: item?.entitled_section || "",
            short_entitled_section: item?.short_entitled_section || "",
            yearId: item?.yearId || item?.year?.id || "", errors: {}, loading: true, saving: false, loadError: "",
        });
        try {
            const response = await axios.get("years");
            this.setState({ years: Array.isArray(response.data) ? response.data : [] });
        } catch (error) {
            this.setState({ loadError: "Les années scolaires n’ont pas pu être chargées." });
        } finally { this.setState({ loading: false }); }
    };

    handleInput = (event) => {
        const { name, value } = event.target;
        this.setState((state) => ({ [name]: value, errors: { ...state.errors, [name]: "" } }));
    };

    storeSection = async () => {
        const entitled = this.state.entitled_section.trim();
        const abbreviation = this.state.short_entitled_section.trim();
        const errors = {};
        if (!entitled) errors.entitled_section = "L’intitulé de la section est obligatoire.";
        if (!abbreviation) errors.short_entitled_section = "L’abréviation est obligatoire.";
        if (Object.keys(errors).length) return this.setState({ errors });

        const data = { entitled_section: entitled, short_entitled_section: abbreviation.toUpperCase(), operation: this.state.id ? "Editer" : "Ajouter", yearId: this.state.yearId || null };
        this.setState({ saving: true, errors: {} });
        try {
            const response = this.state.id ? await axios.put(`sections/${this.state.id}`, data) : await axios.post("sections", data);
            toast.success(response?.data?.msg || (this.state.id ? "La section a été actualisée." : "La section a été créée."));
            this.props.showModal();
        } catch (error) {
            this.setState({ errors: error.response?.data?.errors || {} });
            toast.error(error.response?.data?.msg || "La sauvegarde a échoué.");
        } finally { this.setState({ saving: false }); }
    };

    render() {
        const editing = Boolean(this.props.formData?.id || this.state.id);
        const yearOptions = this.state.years.map((year) => ({ value: year.id, label: year.year || year.title || `Année ${year.id}` }));
        const selectedYear = yearOptions.find((option) => String(option.value) === String(this.state.yearId)) || null;

        return <Modal show={this.props.isModal} onHide={this.props.showModal} onEntered={this.loadForm} backdrop="static" centered dialogClassName="school-section-form">
            <Modal.Header className="school-section-form__header">
                <div className="school-section-form__title">
                    <span><FeatherIcon icon={editing ? "edit-3" : "layers"} size={20} /></span>
                    <div><small>Organisation académique</small><Modal.Title>{editing ? "Modifier la section" : "Créer une section"}</Modal.Title></div>
                </div>
                <button type="button" className="school-section-form__close" onClick={this.props.showModal} aria-label="Fermer"><FeatherIcon icon="x" size={18} /></button>
            </Modal.Header>

            <Modal.Body className="school-section-form__body">
                <p className="school-section-form__intro">Renseignez l’intitulé officiel utilisé dans les documents et une abréviation courte pour les listes administratives.</p>
                {this.state.loadError && <div className="school-section-form__alert"><FeatherIcon icon="alert-circle" size={17} />{this.state.loadError}</div>}
                {this.state.loading ? <div className="school-section-form__loading"><span className="spinner-border spinner-border-sm" />Préparation du formulaire…</div> : <div className="row g-3">
                    <div className="col-12">
                        <label className="school-section-field__label" htmlFor="section-name"><FeatherIcon icon="file-text" size={15} />Intitulé officiel <b>*</b></label>
                        <input id="section-name" className={`school-section-field ${this.state.errors.entitled_section ? "is-invalid" : ""}`} name="entitled_section" value={this.state.entitled_section} onChange={this.handleInput} placeholder="Ex. Enseignement général" autoFocus />
                        {this.state.errors.entitled_section && <small className="school-section-field__error">{this.state.errors.entitled_section}</small>}
                    </div>
                    <div className="col-md-5">
                        <label className="school-section-field__label" htmlFor="section-code"><FeatherIcon icon="tag" size={15} />Abréviation <b>*</b></label>
                        <input id="section-code" className={`school-section-field school-section-field--code ${this.state.errors.short_entitled_section ? "is-invalid" : ""}`} name="short_entitled_section" value={this.state.short_entitled_section} onChange={this.handleInput} placeholder="Ex. EG" maxLength={15} />
                        {this.state.errors.short_entitled_section ? <small className="school-section-field__error">{this.state.errors.short_entitled_section}</small> : <small className="school-section-field__hint">15 caractères maximum.</small>}
                    </div>
                    <div className="col-md-7">
                        <label className="school-section-field__label" htmlFor="section-year"><FeatherIcon icon="calendar" size={15} />Année scolaire</label>
                        <Select inputId="section-year" classNamePrefix="school-section-select" value={selectedYear} onChange={(option) => this.setState({ yearId: option?.value || "" })} options={yearOptions} placeholder="Choisir une année" noOptionsMessage={() => "Aucune année disponible"} isClearable />
                        <small className="school-section-field__hint">Facultatif si la section reste permanente.</small>
                    </div>
                </div>}
            </Modal.Body>

            <Modal.Footer className="school-section-form__footer">
                <span><b>*</b> Champs obligatoires</span>
                <div>
                    <button type="button" className="school-section-form__cancel" onClick={this.props.showModal}>Annuler</button>
                    <button type="button" className="school-section-form__save" onClick={this.storeSection} disabled={this.state.loading || this.state.saving}>
                        {this.state.saving ? <><span className="spinner-border spinner-border-sm" />Sauvegarde…</> : <><FeatherIcon icon="check" size={17} />{editing ? "Actualiser" : "Créer la section"}</>}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>;
    }
}

export default SectionForm;
